export default __webpack_public_path__ + "static/media/img_08.acf643f5.webp";